import { V } from '../../common/Layout';
import { Typography } from '@mui/material';
import React from 'react';
import { Type } from '../attributes';

type TextTypePreviewProps = {
    field: Type;
};

export default (props: TextTypePreviewProps) => {
    const { field } = props;
    return (
        <V>
            <Typography fontSize={'medium'}>{field.typeName}</Typography>
            <Typography fontSize={'small'}>{field.description}</Typography>
        </V>
    );
};
